
export const fbqPageView = (val) => {
    if(window.fbq){
        fbq('track', 'PageView');
    }
}

export const fbqSearch = (val) => {
    if(window.fbq){
        fbq('track', 'Search');
    }
}

export const fbqCustom = (val, obj) => {
    if(window.fbq){
        fbq('trackCustom', val, obj);
    }
}
